import React from 'react';
import './table.css';

const OutlineTable = ({ data, columns, renderRow, renderHeader }) => {
  const dataToDisplay = data;

  return (
    <div className='w-100'>
      <div className='mb-1 outline-header'>{renderHeader()}</div>
      <div className='datatable-scroll'>
        <table
          className='table datatable-basic dataTable no-footer'
          role='grid'
          aria-describedby='DataTables_Table_0_info'
        >
          <tbody>
            {dataToDisplay && dataToDisplay?.length > 0 ? (
              dataToDisplay?.map((rowData, index) => renderRow(rowData, index))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className='text-center'
                  style={{ color: 'var(--color-subtitle)' }}
                >
                  No hay información disponible.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OutlineTable;
